import { createTheme } from "@mui/material/styles";

// Define color palette
const palette = {
  primary: {
    main: "#299B8D", // Deep blue
    light: "#E9C46A", // Lighter blue
    dark: "#E9C46A", // Darker blue
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#ff4081",
    light: "#ff80ab",
    dark: "#f50057",
    contrastText: "#ffffff",
  },
  background: {
    default: "#f4f4f4",
    paper: "#ffffff",
  },
  text: {
    primary: "#000000",
    secondary: "#666666",
    main: "#299B8D",
  },
};

// Define typography with custom sizes and weights
const typography = {
  fontFamily: "Inter, sans-serif",
  h1: {
    fontSize: { xs: "30px", xl: "36px" },
    fontWeight: 400,
    lineHeight: "49.36px",
    fontFamily: "DM Serif Text",
    letterSpacing: "0.37px",
  },
  h2: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "19.3px",
  },
  h3: {
    fontSize: "22px",
    fontWeight: 400,
    lineHeight: "30.16px",
    fontFamily: "'DM Serif Text', serif",
    letterSpacing: "0.37px",
  },
  body1: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "20px",
  },
  body2: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.4,
  },
  button: {
    fontWeight: 500,
    textTransform: "uppercase",
  },
};

// Create the theme
const theme = createTheme({
  palette,
  typography,
  components: {
    // You can customize specific components here

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
        },
        containedPrimary: {
          backgroundColor: palette.primary.main,
          "&:hover": {
            backgroundColor: palette.primary.dark,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        },
      },
    },
  },
});

export default theme;
